import React, { useEffect, useMemo, useState } from "react";
import DivTag from "../../Components/DivComponent/DivTag";
import HeadingTag from "../../Components/HeadingComponent/HeadingTag";
import SelectWithLabelOption from "../../Components/SelectComponent/SelectWithLabelOption";
import TextAreaWithLabel from "../../Components/TextAreaWithLabel/TextAreaWithLabel";
import Button from "../../Components/ButtonComponent/Button";
import ButtonReport from "../../Components/ButtonComponent/ButtonReport";
import InputWithLabel from "../../Components/InputComponent/InputWithLabel";
import {
  retrivePackageByServiceIdService,
  retrivePackageService,
  getAssignedDetailsByID,
} from "../../../services/PackageList/PackageService";
import Option from "../../Components/OptionComponent/Option";
import { asignService } from "../../../services/apiaddservice";
import { showErrorToast, showSuccessToast } from "../../../utils/toastUtils";
import { FaTimes } from "react-icons/fa";
import Loader from "../../../components/Loader/Loader";

const ActivatePopup = ({
  onCloseActivatePop,
  serviceId,
  endPoint,
  serviceName,
  statusId,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [packageData, setPackageData] = useState([]);
  const [assignedData, setAssignedData] = useState([]);
  const [userName, setUserName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [kycStatus, setKycStatus] = useState("");
  const [activationData, setActivationData] = useState({
    packageId: "",
    serviceId: serviceId,
    staffId: "",
    userId: "",
    postUrl: "",
    remarks: "",
    scope: "",
    pay_account_status: "",
    daily_limit: "",
    monthly_limit: "",
    service_status: "",
    environment: "",
    request_count: "",
    login_id: "",
    password: "",
    merchant_code: "",
    scheme_code: "",
    encryption_key: "",
    encryption_iv: "",
    salt: "",
    status: "",
  });

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // adjust as needed

  const totalPages = Math.ceil(assignedData.length / itemsPerPage);
  const paginatedData = assignedData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setActivationData((prev) => ({
  //     ...prev,
  //     [name]: name === "userId" ? value.toUpperCase() : value,
  //   }));
  // };
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "ips") {
      setActivationData({
        ...activationData,
        ips: value.split(",").map((ip) => ip.trim()),
      });
      return;
    }

    if (name === "domains") {
      setActivationData({
        ...activationData,
        domains: value.split(",").map((d) => d.trim()),
      });
      return;
    }

    setActivationData({
      ...activationData,
      [name]: value,
    });
  };

  async function RetrivePackageData() {
    setIsLoading(true);
    try {
      const response = await retrivePackageByServiceIdService({
        serviceId: serviceId,
      });

      setPackageData(response.data);
    } catch (error) {
      setIsLoading(false);
      return error;
    } finally {
      setIsLoading(false);
    }
  }

  async function handleAssignData() {
    setIsLoading(true);
    try {
      const response = await asignService({ formData: activationData });

      if (response.status === 403) {
        showErrorToast(response.data.message);
        return;
      }

      if (response.status === 422) {
        showErrorToast(response.data.message);
        return;
      }

      if (response.status.code === 200) {
        showSuccessToast(response.status.message);

        setActivationData({
          packageId: "",
          serviceId: "",
          staffId: "",
          userId: "",
          postUrl: "",
          remarks: "",
          scope: "",
          pay_account_status: "",
          daily_limit: "",
          monthly_limit: "",
          service_status: "",
          environment: "",
          request_count: "",
          login_id: "",
          password: "",
          merchant_code: "",
          scheme_code: "",
          encryption_key: "",
          encryption_iv: "",
          salt: "",
          status: "",
          restriction_type: "",
          ips: [],
          domains: [],
        });

        onCloseActivatePop();
      }
    } catch (error) {
      showErrorToast("An error occurs while assign");
      setIsLoading(false);
      return;
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    RetrivePackageData();
  }, []);

  // const [showFTFields, setShowFTFields] = useState(false);

  useEffect(() => {
    const fetchAssignedDetails = async () => {
      if (!activationData.userId || activationData.userId.length < 6) return;
      setIsLoading(true);
      try {
        const response = await getAssignedDetailsByID({
          userId: activationData.userId,
        });

        const result = response?.data || response.data.data;
        //  console.log("Assigned Details Response:", result);
        const userName = response?.user?.name;
        const companyName = response?.user?.company_details?.company_name;
        const kycStatus = response?.user?.kyc_status_id;
        setUserName(userName);
        setCompanyName(companyName);
        setKycStatus(kycStatus);

        if (!Array.isArray(result) || result.length === 0) {
          setAssignedData([]);
          return;
        }

        //  Assign full list
        setAssignedData(result);
        // console.log("data",assignedData);

        //  Find matched item based on serviceId
        const matchedItem = result.find(
          (item) => item?.service?.id == serviceId,
        );
        // console.log("mat ID",matchedItem);
        if (!matchedItem) {
          console.log(" No service matched:", serviceId);
          return;
        }

        const firstItem = matchedItem;

        const configs = firstItem?.assignment?.configs || [];

        const ips = configs.filter((c) => c.type === "ip").map((c) => c.value);

        const domains = configs
          .filter((c) => c.type === "domain")
          .map((c) => c.value);

        let restriction_type = "none";
        if (ips.length && domains.length) restriction_type = "both";
        else if (ips.length) restriction_type = "ip";
        else if (domains.length) restriction_type = "domain";

        //  Base activation fields
        let updatedData = {
          ...activationData,
          postUrl: firstItem?.assignment?.domain || "",
          packageId: firstItem?.assignment?.package?.id || "",
          staffId: firstItem?.assignment?.staff_id || "",
          remarks: firstItem?.assignment?.remarks || "",
          scope: firstItem?.assignment?.scope || "",
          pay_account_status:
            firstItem?.service?.payoutAccount?.status?.value || "",
          daily_limit: firstItem?.service?.payoutAccount?.daily_limit || "",
          monthly_limit: firstItem?.service?.payoutAccount?.monthly_limit || "",
          status: firstItem?.assignment?.status?.value || "",
          environment: firstItem?.assignment?.environment || "",
          request_count: firstItem?.assignment?.request_count || "",
          userName: firstItem?.assignment?.user?.name || "",
          preference: firstItem?.service?.preference || "",
          restriction_type,
          ips,
          domains,
          //  NEW — IMPORTANT
          commission_slabs:
            firstItem?.assignment?.charges_commission?.commission_slabs || [],
        };

        //  If endpoint is W-EMANDATE → add special fields
        if (endPoint?.includes("/w-emandate")) {
          const em = firstItem?.service?.emandateService;

          updatedData = {
            ...updatedData,
            login_id: em?.login_id || "",
            password: em?.password || "",
            merchant_code: em?.merchant_code || "",
            scheme_code: em?.scheme_code || "",
            encryption_key: em?.encryption_key || "",
            encryption_iv: em?.encryption_iv || "",
            salt: em?.salt || "",
            status_emandate: em?.status || "",
          };

          //  console.log("✔ eMandate Loaded for service:", serviceId);
        }

        //  Finally set data
        setActivationData(updatedData);
      } catch (error) {
        console.error("Failed to fetch assigned details:", error);
        setAssignedData([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAssignedDetails();
  }, [activationData.userId, endPoint, serviceId]);

  useEffect(() => {
    setCurrentPage(1);
  }, [assignedData]);

  // Get status text and color based on status_id
  const getStatus = (code) => {
    switch (code) {
      case 5:
        return { text: "Active", color: "text-green-600" };
      case 4:
        return { text: "Inactive", color: "text-red-600" };
      case 18:
        return { text: "Deprecated", color: "text-yellow-600" };
      case 19:
        return { text: "Coming Soon", color: "text-blue-600" };
      default:
        return { text: "N/A", color: "text-gray-500" };
    }
  };

  const status = getStatus(statusId);

  useEffect(() => {
    console.log("statusId", statusId);
  }, [statusId]);

  return (
    <DivTag className="fixed inset-0 flex items-start justify-center bg-gray-800 bg-opacity-50 z-50">
      {isLoading && <Loader />}
      <DivTag
        className="bg-white rounded-lg shadow-lg w-full md:w-2/3 mt-1 
                     max-h-[90vh] overflow-y-auto"
      >
        <DivTag className="modal-header flex justify-between items-center p-2 border-b border-gray-200">
          <HeadingTag className="text-xl font-semibold text-red-700">
            Activate:
            <span className="ml-2 text-blue-600 font-bold">{serviceName}</span>
            <span className="ml-2">
              (<span className={status.color}>{status.text}</span>)
            </span>
          </HeadingTag>
          <Button
            type="button"
            className="text-white px-2 py-1 rounded-full hover:text-gray-700 bg-red-500"
            onClick={onCloseActivatePop}
          >
            <FaTimes className="text-xl" />
          </Button>
        </DivTag>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-1 px-2 py-0">
          <div className="w-full mb-1">
            <label htmlFor="UserId" className="block text-black font-semibold">
              Enter UserID
            </label>
            <input
              type="text"
              name="userId"
              id="UserId"
              placeholder="APID0393"
              value={activationData.userId?.toUpperCase() || ""}
              onChange={handleChange}
              required
              className="w-full border border-blue-600 rounded-md px-2 py-1 outline-none focus:ring-2 focus:ring-blue-400"
            />
          </div>

          <SelectWithLabelOption
            DivclassName="w-full"
            label="Activation Type"
            id="scope"
            name="scope"
            value={activationData?.scope || ""}
            onChange={handleChange}
            required={true}
          >
            <option value="" disabled>
              Select Scope
            </option>
            <option value="PORTAL_ACCESS">Portal Access</option>
            <option value="OUTSIDE_PORTAL_ACCESS">API Access</option>
            <option value="BOTH">Both (Portal + API Access)</option>
          </SelectWithLabelOption>

          <InputWithLabel
            DivclassName="w-full"
            label="Enter URL"
            type="text"
            name="postUrl"
            id="Enter_url"
            value={activationData?.postUrl || ""}
            onChange={handleChange}
            required={
              activationData.scope === "OUTSIDE_PORTAL_ACCESS" ||
              activationData.scope === "BOTH"
            }
          />
        </div>

        <div className="flex px-2 py-1 items-center gap-x-20">
          <div className="flex items-center mt-1 text-sm text-black">
            <strong className="mr-1">Name:-</strong>
            <span className="text-green-600">{userName || "-"}</span>
          </div>

          <div className="flex items-center mt-1 text-sm text-black">
            <strong className="mr-1">Company Name:-</strong>
            <span className="text-green-600">{companyName || "-"}</span>
          </div>

          <div className="flex items-center mt-1 text-sm text-black">
            <strong className="mr-1">Kyc Status Id :-</strong>
            <span className="text-green-600">{kycStatus || "-"}</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-1 px-2 py-0">
          <SelectWithLabelOption
            DivclassName="w-full"
            label="Select Package"
            id="Select_sales_emp"
            name="packageId"
            value={activationData?.packageId || ""}
            onChange={handleChange}
            required={true}
          >
            <option value="">Select Package</option>
            {packageData.length > 0 &&
              packageData.map((item, index) => (
                <Option key={index} value={item.package_id}>
                  {item.package_name}( ₹{item?.charge?.amount} )
                </Option>
              ))}
          </SelectWithLabelOption>

          <SelectWithLabelOption
            DivclassName="w-full"
            label="Select Staff"
            id="staffId"
            name="staffId"
            value={activationData?.staffId || ""}
            onChange={handleChange}
            required={true}
          >
            <option value="">Select Staff</option>
            <Option value=""></Option>
          </SelectWithLabelOption>

          <SelectWithLabelOption
            DivclassName="w-full"
            label="status"
            id="status"
            name="status"
            value={activationData?.status || ""}
            onChange={handleChange}
            required={true}
          >
            <option value="" disabled>
              Service Status
            </option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </SelectWithLabelOption>

          <SelectWithLabelOption
            DivclassName="w-full"
            label="Environment"
            id="environment"
            name="environment"
            value={activationData?.environment || ""}
            onChange={handleChange}
            required={true}
          >
            <option value="" disabled>
              select Environment
            </option>
            <option value="PRODUCTION">Production</option>
            <option value="UAT">UAT</option>
          </SelectWithLabelOption>

          <InputWithLabel
            DivclassName="w-full"
            label="Enter Request Count"
            type="text"
            name="request_count"
            id="request_count"
            placeholder="Enter request_count"
            value={activationData?.request_count || ""}
            onChange={handleChange}
            required={activationData?.environment === "UAT"}
          />
          <TextAreaWithLabel
            DivclassName="w-full md:col-span-2"
            label="API UseCase"
            type="text"
            placeholder="Enter the usecase as for the compliance"
            name="remarks"
            value={activationData?.remarks || ""}
            onChange={handleChange}
            required={true}
          />

          <SelectWithLabelOption
            DivclassName="w-full"
            label="Restriction Type"
            id="restriction_type"
            name="restriction_type"
            value={activationData?.restriction_type || "none"}
            onChange={handleChange}
          >
            <option value="none">None</option>
            <option value="ip">IP</option>
            <option value="domain">Domain</option>
            <option value="both">Both</option>
          </SelectWithLabelOption>

          {/* IP INPUT */}
          {(activationData?.restriction_type === "ip" ||
            activationData?.restriction_type === "both") && (
            <div className="w-full">
              <InputWithLabel
                label="Allowed IPs"
                type="text"
                name="ips"
                id="ips"
                placeholder="192.168.1.1,192.168.0.2"
                value={activationData?.ips || ""}
                onChange={handleChange}
              />

              {/* Preview */}
              <div className="flex flex-wrap gap-1 mt-1">
                {(Array.isArray(activationData?.ips)
                  ? activationData.ips
                  : (activationData?.ips || "").split(",")
                )
                  .filter(Boolean)
                  .map((ip, index) => (
                    <span
                      key={index}
                      className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded"
                    >
                      {ip.trim()}
                    </span>
                  ))}
              </div>
            </div>
          )}

          {/* DOMAIN INPUT */}
          {(activationData?.restriction_type === "domain" ||
            activationData?.restriction_type === "both") && (
            <div className="w-full">
              <InputWithLabel
                label="Allowed Domains"
                type="text"
                name="domains"
                id="domains"
                placeholder="https://client.com"
                value={activationData?.domains || ""}
                onChange={handleChange}
              />

              {/* Preview */}
              <div className="flex flex-wrap gap-1 mt-1">
                {(Array.isArray(activationData?.domains)
                  ? activationData.domains
                  : (activationData?.domains || "").split(",")
                )
                  .filter(Boolean)
                  .map((domain, index) => (
                    <span
                      key={index}
                      className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded"
                    >
                      {domain.trim()}
                    </span>
                  ))}
              </div>
            </div>
          )}

          {endPoint?.includes("/idfc/fund-transfer") && (
            <>
              {/*  These fields should show only when condition matches */}
              <SelectWithLabelOption
                DivclassName="w-full"
                label="Payout A/c Status"
                id="pay_account_status"
                name="pay_account_status"
                value={activationData?.pay_account_status || ""}
                onChange={handleChange}
                required={true}
              >
                <option value="" disabled selected>
                  {" "}
                  Select Pay Ac. Status
                </option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </SelectWithLabelOption>

              <InputWithLabel
                DivclassName="w-full"
                label="Daily Limit"
                type="text"
                name="daily_limit"
                id="daily_limit"
                value={activationData?.daily_limit || ""}
                onChange={handleChange}
                required={true}
              />

              <InputWithLabel
                DivclassName="w-full"
                label="Monthly Limit"
                type="text"
                name="monthly_limit"
                id="monthly_limit"
                value={activationData?.monthly_limit || ""}
                onChange={handleChange}
                required={true}
              />
            </>
          )}

          {endPoint?.includes("/w-emandate") && (
            <>
              <InputWithLabel
                DivclassName="w-full"
                label="Login ID"
                type="text"
                name="login_id"
                id="login_id"
                value={activationData?.login_id || ""}
                onChange={handleChange}
                required={true}
              />

              <InputWithLabel
                DivclassName="w-full"
                label="Password"
                type="password"
                name="password"
                id="password"
                value={activationData?.password || ""}
                onChange={handleChange}
                required={true}
              />

              <InputWithLabel
                DivclassName="w-full"
                label="Merchant Code"
                type="text"
                name="merchant_code"
                id="merchant_code"
                value={activationData?.merchant_code || ""}
                onChange={handleChange}
                required={true}
              />

              <InputWithLabel
                DivclassName="w-full"
                label="Scheme Code"
                type="text"
                name="scheme_code"
                id="scheme_code"
                value={activationData?.scheme_code || ""}
                onChange={handleChange}
                required={true}
              />

              <InputWithLabel
                DivclassName="w-full"
                label="Encryption Key"
                type="text"
                name="encryption_key"
                id="encryption_key"
                value={activationData?.encryption_key || ""}
                onChange={handleChange}
                required={true}
              />

              <InputWithLabel
                DivclassName="w-full"
                label="Encryption IV"
                type="text"
                name="encryption_iv"
                id="encryption_iv"
                value={activationData?.encryption_iv || ""}
                onChange={handleChange}
                required={true}
              />

              <InputWithLabel
                DivclassName="w-full"
                label="Salt"
                type="text"
                name="salt"
                id="salt"
                value={activationData?.salt || ""}
                onChange={handleChange}
                required={true}
              />

              <SelectWithLabelOption
                DivclassName="w-full"
                label="status emandate"
                id="status_emandate"
                name="status_emandate"
                value={activationData?.status_emandate || ""}
                onChange={handleChange}
                required={true}
              >
                <option value="" disabled>
                  Select Emandate Status
                </option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </SelectWithLabelOption>
            </>
          )}
        </div>

        {endPoint?.includes("/idfc/fund-transfer") && (
          <div className="flex justify-center">
            <table className="w-1/2 border border-gray-300 mt-3 text-sm">
              <thead className="bg-gray-100 text-gray-700">
                <tr className="text-xs">
                  <th className="border px-2 py-1">Start Amount</th>
                  <th className="border px-2 py-1">End Amount</th>
                  <th className="border px-2 py-1">Mode</th>
                  <th className="border px-2 py-1">Commission Type</th>
                  <th className="border px-2 py-1">Amount</th>
                </tr>
              </thead>

              <tbody>
                {activationData?.commission_slabs?.map((slab, index) => (
                  <tr key={index} className="odd:bg-white even:bg-gray-50">
                    {/* Start */}
                    <td className="border px-1 py-0">{slab.start_amount}</td>

                    {/* End */}
                    <td className="border px-1 py-0">{slab.end_amount}</td>

                    {/* Mode */}
                    <td className="border px-1 py-0">{slab.mode}</td>

                    {/* Commission Type */}
                    <td className="border px-1 py-0">{slab.commission_type}</td>

                    {/* Amount */}
                    <td className="border px-1 py-0">{slab.amount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <DivTag className="flex justify-center p-1 border-t border-gray-200"></DivTag>

        <DivTag className="flex justify-center p-1 border-t border-gray-200">
          <ButtonReport
            type="button"
            onClick={handleAssignData}
            className=""
            text="Activate Now"
          />
        </DivTag>

        {Array.isArray(assignedData) && assignedData.length > 0 ? (
          <>
            <table className="w-full border-collapse text-[9.5px] leading-tight">
              <thead>
                <tr className="bg-blue-700 text-white">
                  <th className="border border-gray-300 px-1 py-[2px]">
                    Amount
                  </th>
                  <th className="border border-gray-300 px-1 py-[2px]">Type</th>
                  <th className="border border-gray-300 px-1 py-[2px]">
                    Package
                  </th>
                  <th className="border border-gray-300 px-1 py-[2px]">
                    Environment
                  </th>
                  <th className="border border-gray-300 px-1 py-[2px]">
                    Restriction Type
                  </th>
                  <th className="border border-gray-300 px-1 py-[2px]">
                    Service
                  </th>
                  <th className="border border-gray-300 px-1 py-[2px]">
                    Activation Fee
                  </th>

                  <th className="border border-gray-300 px-1 py-[2px]">
                    Preference
                  </th>
                  <th className="border border-gray-300 px-1 py-[2px]">
                    Status
                  </th>
                </tr>
              </thead>

              <tbody>
                {paginatedData.map((item, idx) => (
                  <tr
                    key={idx}
                    className={`
          ${idx % 2 === 0 ? "bg-gray-50" : "bg-white"}
          hover:bg-gray-200 transition
        `}
                  >
                    <td className="border px-1 py-[2px]">
                      {item?.assignment?.charges_commission?.service_charge
                        ?.amount ?? "N/A"}
                    </td>

                    <td className="border px-1 py-[2px]">
                      {item?.assignment?.charges_commission?.service_charge
                        ?.charge_type ?? "N/A"}
                    </td>

                    <td className="border px-1 py-[2px]">
                      {item?.assignment?.package?.name ?? "N/A"}
                    </td>
                    <td className="border px-1 py-[2px]">
                      {item?.assignment?.environment ?? "N/A"}
                    </td>

                    <td className="border px-1 py-[2px]">
                      {item?.assignment?.restriction_type ?? "N/A"}
                    </td>

                    <td className="border px-1 py-[2px]">
                      {item?.service?.service_name ?? "N/A"}
                    </td>
                    <td className="border px-1 py-[2px]">
                      {item?.service?.activation_fee ?? "N/A"}
                    </td>

                    <td className="border px-1 py-[2px]">
                      {item?.service?.preference ?? "N/A"}
                    </td>

                    <td
                      className={`border px-1 py-[1px] text-white text-center font-semibold rounded-sm
            ${
              item?.assignment?.status?.value === "active"
                ? "bg-green-500"
                : "bg-red-500"
            }
          `}
                    >
                      {item?.assignment?.status?.value ?? "N/A"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Pagination Controls */}
            <div className="flex justify-center items-center space-x-2 mt-2 mb-2">
              <button
                onClick={handlePrev}
                disabled={currentPage === 1}
                className={`px-1 py-0 rounded text-white 
      ${
        currentPage === 1
          ? "bg-gray-400 cursor-not-allowed"
          : "bg-blue-600 hover:bg-blue-700"
      }`}
              >
                Prev
              </button>

              <span className="text-xs font-semibold">
                Page {currentPage} of {totalPages}
              </span>

              <button
                onClick={handleNext}
                disabled={currentPage === totalPages}
                className={`px-1 py-0 rounded text-white 
      ${
        currentPage === totalPages
          ? "bg-gray-400 cursor-not-allowed"
          : "bg-blue-600 hover:bg-blue-700"
      }`}
              >
                Next
              </button>
            </div>
          </>
        ) : (
          <p className="text-gray-500 mt-4 text-sm">
            No assigned data available.
          </p>
        )}
      </DivTag>
    </DivTag>
  );
};

export default ActivatePopup;
